// removed by extract-text-webpack-plugin
module.exports = {"roundedBadge":"roundedBadge___2xnMw","small":"small___5d-2x","primary":"primary___1Oh1q","brand":"brand___xLQ1c","terciary":"terciary___39a-5","correct":"correct___3NCU3","wrong":"wrong___2gtTJ","accent":"accent___lvSpl","negative":"negative___2WHs5","black":"black___1UBKL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RoundedBadge/index.scss
// module id = 103
// module chunks = 0